import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "libraryHidden",
    "preview",
    "previewImage",
    "uploadField",
    "modal"
  ]
  static values = {
    libraryOnly: { type: Boolean, default: false }
  }

  openLibrary(event) {
    event?.preventDefault()
    this.modalTarget.showModal()
  }

  closeLibrary(event) {
    event?.preventDefault()
    this.modalTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.modalTarget.close()
    }
  }

  selectLibrary(event) {
    event.preventDefault()
    const button = event.currentTarget
    const photoId = button.dataset.photoId
    const photoUrl = button.dataset.photoUrl

    this.libraryHiddenTarget.value = photoId
    this.previewImageTarget.src = photoUrl
    this.previewTarget.classList.remove("hidden")

    if (this.hasUploadFieldTarget) {
      this.dispatchClearUpload()
      this.uploadFieldTarget.classList.add("hidden")
    }

    this.closeLibrary()
  }

  removeLibrary(event) {
    event?.preventDefault()

    this.libraryHiddenTarget.value = ""
    this.previewTarget.classList.add("hidden")
    this.previewImageTarget.src = ""

    if (this.hasUploadFieldTarget) {
      this.uploadFieldTarget.classList.remove("hidden")
    }
  }

  dispatchClearUpload() {
    if (!this.hasUploadFieldTarget) return

    this.uploadFieldTarget.dispatchEvent(
      new CustomEvent("media-picker:clear-upload", { bubbles: true })
    )
  }
}
